import {DOCUMENT} from '@angular/common';
import {AfterViewInit, Directive, Inject, Input, OnDestroy, OnInit} from '@angular/core';

import Parallax from 'parallax-js';
import {ParallaxProperties} from './model/parallaxProperties';
export class WrapperDirective implements OnInit, AfterViewInit, OnDestroy {

   id: string;

  
  parallaxOptions: ParallaxProperties;
private parallaxInstance: Parallax;
/**
 * @param {?} document
 */
constructor(
private document: any) {
  }
/**
 * @return {?}
 */
ngOnInit() {
    if (!this.id) {
      throw new Error('id is required');
    }
  }
/**
 * @return {?}
 */
ngAfterViewInit(): void {
    console.log('this.id-------------------------' + this.id);
    const /** @type {?} */ container = this.document.getElementById(this.id);
    this.parallaxInstance = new Parallax(container, this.parallaxOptions);
  }
/**
 * @return {?}
 */
ngOnDestroy(): void {
    this.parallaxInstance.disable();
  }

  /*
  set parallaxOptions(parallaxOptions: ParallaxProperties) {
    this._parallaxOptions = parallaxOptions;
    const keys = Object.keys(parallaxOptions);
    for (const key in keys) {
      if (keys[key]) {
        this._parallaxOptions = Object.assign(this[key] !== undefined ? {[key]: this[key]} : {});
      }
    }
   this._parallaxOptions = Object.keys(parallaxOptions).reduce((acc, key) =>
         Object.assign(acc, this[key] !== undefined ? {[key]: this[key]} : {}),
       {});
  }

  get parallaxOptions(): ParallaxProperties {
    return this._parallaxOptions;
  }*/
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[parallaxWrapper]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: undefined, decorators: [{ type: Inject, args: [DOCUMENT, ] }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'id': [{ type: Input },],
'parallaxOptions': [{ type: Input },],
};
}

function WrapperDirective_tsickle_Closure_declarations() {
/** @type {?} */
WrapperDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
WrapperDirective.ctorParameters;
/** @type {?} */
WrapperDirective.propDecorators;
/** @type {?} */
WrapperDirective.prototype.id;
/** @type {?} */
WrapperDirective.prototype.parallaxOptions;
/** @type {?} */
WrapperDirective.prototype.parallaxInstance;
/** @type {?} */
WrapperDirective.prototype.document;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
